import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { FORMLY_CONFIG, FormlyModule } from '@ngx-formly/core';
import { FormlyMaterialModule } from '@ngx-formly/material';
import { FormlyMatDatepickerModule } from '@ngx-formly/material/datepicker';
import { LoadingService } from '@app/core/services';
// eslint-disable-next-line import/order
import { SharedModule } from '../shared.module';
// eslint-disable-next-line import/order
import { FormlyWrapperAddonsComponent } from './addons.wrapper';
import {
	AccountFilterComponent,
	AccountRangeTableComponent,
	DeductionGradingTableComponent,
	FieldElementRangeComponent,
	FormComponent,
	FormGroupRepeatComponent,
	FormlyAccountPercentageRepeatComponent,
	FormlyAutocompleteTypeComponent,
	FormlyDateRangeTypeComponent,
	FormlyDecimalInputComponent,
	FormlyKababComponent,
	FormlyMaskedInputComponent,
	FormlyMatButtonComponent,
	FormlyMessageListComponent,
	FormlyMultiSelectChipsComponent,
	FormlyPositiveIntegersInputComponent,
	FormlyRepeatTypeComponent,
	FormlySpinnerComponent,
	FormlyTableComponent,
	FormlyTabsComponent,
	FormlyToggleInputComponent,
	MultiuseSearchInputComponent,
	PlainTextInputComponent,
	PrGradingTableComponent,
	SectionAccordionWrapperComponent,
	SectionReportFieldWrapperComponent,
	SectionReportWrapperComponent,
	SectionSimpleTitleWrapperComponent,
	SectionSimpleWrapperComponent,
	SectionSingleFieldWrapperComponent,
	SectionWrapperComponent,
	SelectSearchComponent,
	SelectWithModalComponent,
	TooltipComponent,
	UibDropdownComponent,
	VerticalSpacerComponent,
} from './components';
import { FormlyAccountAutocompleteTypeComponent } from './components/account-autocomplete.type';
import { FormlyFieldButtonComponent } from './components/button-type.component';
import { FormlyChipListComponent } from './components/chip-list-type.component';
import { FormlyDatepickerTypeComponent } from './components/datepicker-type.component';
import { FiltersComponent } from './components/filters/filters.component';
import { FormlyMultiCheckboxComponent } from './components/multi-checkbox/multi-checkbox.component';
import { FormlyMultiselectAllComponent } from './components/multiselect-all/multiselect-all.component';
import { MultiselectAutocompleteComponent } from './components/multiselect-autocomplete/multiselect-autocomplete.component';
import { FormlyTimePickerComponent } from './components/time-picker/time-picker.component';
import { VendorAutocompleteComponent } from './components/vendor-autocomplete/vendor-autocomplete.component';
import { generateFormlyConfig } from './config';
import { PlainTextWrapperComponent } from './plaintext.wrapper';

const components = [
	AccountFilterComponent,
	AccountRangeTableComponent,
	DeductionGradingTableComponent,
	FieldElementRangeComponent,
	FiltersComponent,
	FormComponent,
	FormGroupRepeatComponent,
	FormlyAccountPercentageRepeatComponent,
	FormlyAutocompleteTypeComponent,
	FormlyAccountAutocompleteTypeComponent,
	FormlyChipListComponent,
	FormlyDatepickerTypeComponent,
	FormlyDateRangeTypeComponent,
	FormlyDecimalInputComponent,
	FormlyFieldButtonComponent,
	FormlyKababComponent,
	FormlyMaskedInputComponent,
	FormlyMatButtonComponent,
	FormlyMessageListComponent,
	FormlyMultiCheckboxComponent,
	FormlyMultiselectAllComponent,
	FormlyMultiSelectChipsComponent,
	FormlyPositiveIntegersInputComponent,
	FormlyRepeatTypeComponent,
	FormlySpinnerComponent,
	FormlyTableComponent,
	FormlyTabsComponent,
	FormlyTimePickerComponent,
	FormlyToggleInputComponent,
	FormlyWrapperAddonsComponent,
	MultiselectAutocompleteComponent,
	MultiuseSearchInputComponent,
	PlainTextInputComponent,
	PlainTextWrapperComponent,
	PrGradingTableComponent,
	SectionAccordionWrapperComponent,
	SectionReportFieldWrapperComponent,
	SectionReportWrapperComponent,
	SectionSimpleTitleWrapperComponent,
	SectionSimpleWrapperComponent,
	SectionSingleFieldWrapperComponent,
	SectionWrapperComponent,
	SelectWithModalComponent,
	VerticalSpacerComponent,
	FormlyWrapperAddonsComponent,
	PlainTextWrapperComponent,
	PlainTextInputComponent,
	PrGradingTableComponent,
	FormlyTableComponent,
	FormlyDatepickerTypeComponent,
	TooltipComponent,
	UibDropdownComponent,
	SelectSearchComponent,
	VendorAutocompleteComponent,
];

@NgModule({
	exports: [...components, FormlyModule],
	imports: [
		CommonModule,
		SharedModule,
		FormsModule,
		ReactiveFormsModule,
		FormlyMatDatepickerModule,
		MatAutocompleteModule,
		FormlyModule.forRoot(),
		FormlyMaterialModule,
		...components,
	],
	providers: [{ provide: FORMLY_CONFIG, multi: true, useFactory: generateFormlyConfig, deps: [HttpClient, LoadingService] }],
})
export class LinqFormsModule {}
